import { Currency, isCurrency } from "@hopper-b2b/types";

const B2B_CURRENCY_PREFERENCE_KEY = "b2b-currency-preference";

export const getCurrencyFromStorage = (): Currency | undefined => {
  try {
    const fromStorage = localStorage?.getItem(B2B_CURRENCY_PREFERENCE_KEY);

    if (
      fromStorage !== null &&
      fromStorage !== undefined &&
      fromStorage !== "" &&
      isCurrency(fromStorage)
    ) {
      return fromStorage;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  } catch (_e) {
    //console.warn("storage unavailable")
  }

  return undefined;
};

export const setCurrency = (currency: Currency) => {
  localStorage.setItem(B2B_CURRENCY_PREFERENCE_KEY, currency);
};

export const getCurrencySymbol = (
  threeLetterCurrencyName: string,
  language = "en"
) => {
  const dummyAmount = 0;
  return dummyAmount
    .toLocaleString(language, {
      style: "currency",
      currency: threeLetterCurrencyName,
    })
    .replace(/\d+([,.]\d+)?/, "");
};

export const extractCurrencySymbol = (amountInText: string) => {
  return amountInText.replace(/\d+([,.]\d+)?/, "");
};
